exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#welcome{background:url(\"/public/images/site/background-welcome.svg\") no-repeat 50% 50%;background-color:#0cb9c9;display:table;height:100%;width:100%;background-position-y:bottom;background-size:cover}.index-kids{background-image:url(/public/images/site/index-background.svg)}.index-kids,.index-other{background-repeat:no-repeat;background-size:100%;text-align:-webkit-center;display:table;position:relative;width:100%}.index-other{background-image:url(/public/images/site/index-other-background.svg)}.profile-background{background-image:url(/public/images/site/profile-background.svg);background-repeat:no-repeat;background-size:100%;text-align:-webkit-center;display:table;position:relative;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33ce5734","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/HomeRegistro.vue
// module id = 467
// module chunks = 0